import React, { Component } from "react";
import {
  ElementsConsumer,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement
} from '@stripe/react-stripe-js'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions";
import { DonationDetails } from "./DonationDetails";

export class StripePaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardNumber: "",
      cardNumberIsValid: false,
      month: "",
      year: "",
      expirationDateIsValid: false,
      securityCode: "",
      securityCodeIsValid: false,
      showErrors: false,
      formSubmitted: false,
      showSecurityCodeInfo: false,
      creditCardImagePath: require("./../../images/card-visa.png"),
      creditCardType: "",
      creditCardSecurityCodeNumbers: 3,
      cardNumberValidationMessage: "",
      expDateValidationMessage: "",
      securityCodeValidationMessage: "",
    };
  }

  isFormValid() {
    const { cardNumberIsValid, expirationDateIsValid, securityCodeIsValid } =
      this.state;
    return cardNumberIsValid && expirationDateIsValid && securityCodeIsValid;
  }

  submitPayment() {
    const isFormValid = this.isFormValid();
    const { donationFromProcessing, stripe, elements } = this.props;

    if (!donationFromProcessing || !donationFromProcessing.intentClientSecret || !stripe || !elements) {
      return;
    }

    // Stripe requested form submit disable because the handleCardPayment can take time
    if (this.state.formSubmitted || !isFormValid) {
      return;
    }

    this.setState({ showErrors: true, formSubmitted: true });

    console.log('elements', elements)
    const data = {
      payment_method: {
        card: elements.getElement(CardNumberElement),
        billing_details: {
          email: this.props.personalDetails.email,
        },
      },
    };

    stripe.confirmCardPayment(donationFromProcessing.intentClientSecret, data).then((response) => {
      if (response) {
        this.setState({ stripePaymentResponse: response });
      }
      this.setState({ formSubmitted: false });
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.submitPayment();
  }

  handleCardChange(event) {
    const brand = event.brand;

    if (brand) {
      if (brand === "amex") {
        this.setState({
          cardNumberIsValid: event.complete,
          creditCardType: brand,
          creditCardSecurityCodeNumbers: 4,
          cardNumberValidationMessage: event.error ? event.error.message : "",
        });
      } else {
        this.setState({
          cardNumberIsValid: event.complete,
          creditCardType: brand,
          creditCardSecurityCodeNumbers: 3,
          cardNumberValidationMessage: event.error ? event.error.message : "",
        });
      }
    } else {
      this.setState({
        cardNumberIsValid: event.complete,
        creditCardType: "",
        creditCardSecurityCodeNumbers: 3,
        cardNumberValidationMessage: event.error ? event.error.message : "",
      });
    }
  }

  handleExpDateChange(event) {
    this.setState({
      expirationDateIsValid: event.complete,
      expDateValidationMessage: event.error ? event.error.message : "",
    });
  }

  handleSecurityCodeChange(event) {
    this.setState({
      securityCodeIsValid: event.complete,
      securityCodeValidationMessage: event.error ? event.error.message : "",
    });
  }

  showSecurityCodeInfo() {
    this.setState({
      showSecurityCodeInfo: !this.state.showSecurityCodeInfo,
    });
  }

  render() {
    const isFormValid = this.isFormValid();

    const { amount, currency, errorMsg, globalError, charityDetails } =
      this.props;
    const stripePaymentResponse = this.state.stripePaymentResponse;
    if (stripePaymentResponse) {
      const donorEmail = this.props.personalDetails
        ? this.props.personalDetails.email
        : null;
      const paymentResponseStatus =
        stripePaymentResponse?.last_payment_error ||
          stripePaymentResponse?.paymentIntent?.last_payment_error ||
          stripePaymentResponse?.error
          ? "error"
          : "success";

      const { contribution } = charityDetails;

      const newLocation = "/status?transaction.status=" +
        paymentResponseStatus +
        "&charityName=" +
        charityDetails.charity.name +
        "&projectName=" +
        charityDetails.title +
        "&publiid=" +
        charityDetails.charity.charityPublicId +
        "&id=" +
        stripePaymentResponse.id +
        "&donorEmail=" +
        encodeURIComponent(donorEmail) +
        "&ecommerceProject=" +
        charityDetails.ecommerceProject + (contribution ? "&redirectToCharityThankYouPage=true" : "");
      window.location.href = newLocation;
    }

    return (
      <form onSubmit={(e) => this.handleSubmit(e)}>
        <div id="stripe-payment-form">
          <div
            className={
              "global-error-container " +
              (globalError ||
                errorMsg ||
                ((this.state.cardNumberValidationMessage ||
                  this.state.expDateValidationMessage ||
                  this.state.securityCodeValidationMessage) &&
                  this.state.showErrors)
                ? ""
                : "hidden")
            }
          >
            <div className="error-header">
              {globalError ? "Gateway Error" : "Validation Error"}
            </div>
            <div className="error-message">{globalError || errorMsg}</div>
            <div className="error-message">
              {this.state.cardNumberValidationMessage}
            </div>
            <div className="error-message">
              {this.state.expDateValidationMessage}
            </div>
            <div className="error-message">
              {this.state.securityCodeValidationMessage}
            </div>
          </div>
          <div id="payment-details-bubble">
            <div id="payment-details-container">
              <div id="payment-details-title">
                <div id="card-icons">
                  <img src={require("./../../images/card-visa.png")} alt="card-visa" />
                  <img
                    src={require("./../../images/card-visa-electron.png")}
                    alt="card-visa-electron"
                  />
                  <img
                    src={require("./../../images/card-master-card.png")}
                    alt="card-master-card"
                  />
                  <img
                    src={require("./../../images/card-maestro.png")}
                    alt="card-maestro"
                  />
                  <img src={require("./../../images/card-amex.png")} alt="card-amex" />
                </div>
                <div id="card-details">Card Details</div>
              </div>
              <div id="card-number-row" className="row">
                <label className="stripe-field-label" htmlFor="card-number">
                  Card number
                </label>
                <div id="card-number" className="stripe-input-container">
                  <CardNumberElement
                    onChange={(e) => this.handleCardChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <label className="stripe-field-label">Expiration Date</label>
                <div id="card-expire" className="stripe-input-container">
                  <CardExpiryElement
                    onChange={(e) => this.handleExpDateChange(e)}
                  />
                </div>
              </div>
              <div className="row" id="card-code-row">
                <label className="stripe-field-label" htmlFor="security-code">
                  Security code
                </label>
                <div id="card-cvc" className="stripe-input-container">
                  <CardCvcElement
                    onChange={(e) => this.handleSecurityCodeChange(e)}
                  />
                </div>

                <div id="security-code-text">
                  The
                  <span>
                    {this.state.creditCardSecurityCodeNumbers}
                    &nbsp;digits
                  </span>{" "}
                  on the back of your card.{" "}
                  <span
                    id="security-code-information-question"
                    onClick={() => this.showSecurityCodeInfo()}
                  >
                    ?
                  </span>
                </div>

                <div
                  className={
                    "security-code-explanation " +
                    (this.state.showSecurityCodeInfo ? "" : "hidden")
                  }
                >
                  <img
                    src={require("./../../images/card-back-security-code.png")}
                    alt="card-back-security-code"
                    className={
                      this.state.creditCardType !== "amex" ? "" : "hidden"
                    }
                  />
                  <img
                    src={require("./../../images/card-front-security-code-amex.png")}
                    alt="card-front-security-code-amex"
                    className={
                      this.state.creditCardType === "amex" ? "" : "hidden"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <button id="donate-button" type="submit" disabled={!isFormValid || this.state.formSubmitted || stripePaymentResponse || !this.props.donationFromProcessing}>
            {!this.state.formSubmitted && !stripePaymentResponse && <>
              <img src={require("./../../images/check-white.svg")} alt="check-white-logo" />
              {charityDetails && charityDetails.ecommerceProject
                ? "Pay "
                : "Donate "}
              {currency}
              {DonationDetails.addedExtraZero(amount)}
            </>}
            {(this.state.formSubmitted || stripePaymentResponse) && "Loading..."}
          </button>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    donationFromProcessing: state.donationFormReducer.donationFromProcessing,
    errorMsg: state.donationFormReducer.errorMsg,
    globalError: state.donationFormReducer.globalError,
    stripePaymentResponse: state.donationFormReducer.stripePaymentResponse,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export const InjectedStripePaymentFrom = (props) => (
  <ElementsConsumer>
    {({stripe, elements}) => (
      <StripePaymentForm stripe={stripe} elements={elements} {...props}/>
    )}
  </ElementsConsumer>
);

export default 
  connect(mapStateToProps, mapDispatchToProps)(InjectedStripePaymentFrom);
